import { clx } from "../../../helpers/components"
import style from "./style.module.scss"

export function PartenerSectionTitle({title, className, ...props}){
    return(
        <h3 className={clx(style.h3, style.h3)} {...props}>{title}</h3>
    )
}